export const getCarouselLayoutStyles = (components, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' } = {}) => ({
  carouselLayoutContainer: {
    position: 'relative',
    width: '100%',
  },

  adPreviewCarousel: {
    position: 'relative',

    '& .carousel-inner': {
      paddingBottom: 64,

      // '& > .item.active': {
      //   paddingLeft: 24,
      //   paddingRight: 24,
      // },
    },
    '& ol.carousel-indicators': {
      position: 'absolute',
      width: 'auto',

      '& li': {
        background: 'none',
        border: '1px solid #605E5C',
        borderRadius: 10,
        margin: '0 10px 0 0',
        height: 10,
        width: 10,
      },

      '& li.active': {
        background: palette.themePrimary,
        border: `1px solid ${palette.themePrimary}`,
      },
    },

    '& .carousel-controls': {
      display: 'none',
    },

    '& .carousel-control': {
      color: palette.themePrimary,
      position: 'absolute',
      left: 'auto',
      top: 'auto',
      right: 0,
      bottom: 0,
      height: 32,
      width: 20,
      margin: '20px 24px',
      textShadow: 'none',
      background: 'white',

      '&:focus': {
        outline: `1px solid ${palette.neutralSecondary}`,
      },

      '&.left': {
        position: 'absolute',
      },

      '&.right': {
        position: 'absolute',
      },

      '& .glyphicon-chevron-left, & .glyphicon-chevron-right': {
        fontFamily: iconFontFamily,
        position: 'relative',
        top: 'auto',
        right: 'auto',
        bottom: 'auto',
        left: 'auto',
        margin: 0,
        fontSize: 16,
        lineHeight: 1,
        verticalAlign: 0,
      },
    },
  },
  baseCarouselLayoutStyles: {
    '& ol.carousel-indicators': {
      bottom: 0,
      left: 20,
      margin: '20px 24px',
    },
    '& .carousel-control.left': {
      left: -5,
      bottom: -7,
    },
    '& .carousel-control.right': {
      left: 105,
      bottom: -7,
    },
  },
  playPauseButtons: {
    position: 'absolute',
    left: 156,
    bottom: 13.5,
    display: 'initial !important',

    '& span': {
      color: palette.themePrimary,
    },
  },

  customCarouselWrapper: {
    '& .custom-carousel-controls-and-indicators': {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      position: 'absolute',
      bottom: 3,
      margin: [10, 15],

      '& ol.carousel-indicators': {
        position: 'relative !important',
        top: 'unset !important',
        left: 'unset !important',
        right: 'unset !important',
        bottom: '2px !important',
        margin: '0px 0px 0px 10px !important',
        padding: 'unset !important',
        width: 'auto',

        '& li': {
          background: 'none',
          border: '1px solid #605E5C',
          borderRadius: 10,
          margin: '0 10px 0 0',
          height: 10,
          width: 10,
        },
        '& li.active': {
          background: palette.themePrimary,
          border: `1px solid ${palette.themePrimary}`,
        },
      },

      '& .carousel-control': {
        position: 'relative !important',
        margin: '0px !important',
        background: 'white',
        top: 'unset !important',
        left: 'unset !important',
        right: 'unset !important',
        bottom: 'unset !important',
        color: palette.themePrimary,

        height: 32,
        width: 20,
        textShadow: 'none',

        '&:focus': {
          outline: `1px solid ${palette.neutralSecondary}`,
        },

        '& .glyphicon-chevron-left, & .glyphicon-chevron-right': {
          fontFamily: iconFontFamily,
          position: 'relative',
          top: 'auto',
          right: 'auto',
          bottom: 'auto',
          left: 'auto',
          margin: 0,
          fontSize: 16,
          lineHeight: 1,
          verticalAlign: 0,
        },
      },

      '& $playPauseButtons': {
        position: 'relative !important',
        display: 'initial !important',
        left: 'unset !important',
        top: 'unset !important',
        bottom: '1px !important',
      },
    },
  },
});
